<template>
  <vue-apex-charts
    type="radialBar"
    :height="height"
    :options="radialBarChart.chartOptions"
    :series="radialBarChart.series"
  ></vue-apex-charts>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    VueApexCharts
  },
  props: ['series', 'labels', 'height'],
  data () {
    return {
      radialBarChart: {
        series: this.series,
        chartOptions: {
          labels: this.labels,
          colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: '22px'
                },
                value: {
                  fontSize: '16px'
                },
                total: {
                  show: true,
                  label: 'Total',
                  formatter: () => {
                    const reducer = (acc, val) => acc + val
                    return this.series.reduce(reducer, 1)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style>
</style>